/**
 * Class names applied by the project card styled roots and parts, exported so
 * host apps can target the same regions when composing custom card content.
 */
export const projectCardClasses = {
    cardContainer: "project-card-container",
    cardWrapper: "project-card-wrapper",
    cardWrapperSelectable: "project-card-selectable",
    cardWrapperSelected: "project-card-selected",
    selectionCheckbox: "project-card-selection-checkbox",
    cardInner: "project-card-inner",
    thumbnailWrapper: "project-card-thumbnail",
    content: "project-card-content",
    topSection: "project-card-top-section",
    name: "project-card-name",
    description: "project-card-description",
    authorRow: "project-card-author-row",
    authorRowInner: "project-card-author-row-inner",
    authorRowTrailing: "project-card-author-row-trailing",
    authorSeparator: "project-card-author-separator",
    privacyIcon: "project-card-privacy-icon",
    starMetricButton: "project-card-star-button",
    moreHorizIconButton: "project-card-more-button",
    metricRow: "project-card-metric-row",
    metricRowInner: "project-card-metric-row-inner",
    metricRowCollapsed: "project-card-metric-row-collapsed",
    metricShowMore: "project-card-metric-show-more",
    metricFullLabel: "project-card-metric-full-label",
    metricCompactLabel: "project-card-metric-compact-label",
} as const;
